export default "__VITE_ASSET__9f40b952__"